import { PayrollDetails } from './PayrollTable';
import Data from './Data/data.json'

export const data = Data;